import {
  DESCRIPTION_MAX_LENGTH,
  DESCRIPTION_MIN_LENGTH,
  FILE_MAX_SIZE,
  IMAGE_MAX_SIZE,
  MAX_AGE,
  MAX_COURTS,
  MAX_FULL_NAME_LENGTH,
  MAX_NAME_LENGTH,
  MAX_PASSWORD_LENGTH,
  MAX_RATING,
  MIN_AGE,
  MIN_COURTS,
  MIN_DIGIT_AFTER_DECIMAL,
  MIN_PASSWORD_LENGTH,
  MIN_RATING,
  MIN_SCORE_POINTS_2,
  MIN_TEAMS,
  TITLE_MAX_LENGTH,
  TOTAL_TEAMS,
  TOTAL_WAITLIST,
} from './Common'

export const EMAIL_REQUIRED = 'Email is required.'

export const CLUB_REQUIRED = 'Club name is required.'

export const DIRECTOR_NAME_REQUIRED = 'Director name is required.'

export const PASSWORD_REQUIRED = 'Password is required.'
export const PASSWORD_MIN_LENGTH = `Password must be at least ${MIN_PASSWORD_LENGTH} characters long.`
export const PASSWORD_MAX_LENGTH = `Password must not exceed ${MAX_PASSWORD_LENGTH} characters.`
export const PASSWORD_ONE_NUMBER = 'Password must contain at least one number'
export const PASSWORD_NO_WHITESPACE = 'Whitespace is not allowed.'
export const PASSWORD_LETTERS_NUMBERS = 'Password must contain letters and numbers'
export const NAME_MAX_LENGTH = `Only ${MAX_NAME_LENGTH} characters are allowed`
export const FULL_NAME_MAX_LENGTH = `Only ${MAX_FULL_NAME_LENGTH} characters are allowed`
export const PASSWORD_MATCH = 'Please enter a matching password.'
export const PASSWORD_STRENGTH = `A minimum ${MIN_PASSWORD_LENGTH} characters password containing a combination of uppercase or lowercase letters and numbers are required.`
export const EMAIL_INVALID = 'Invalid email address.'
export const EMAIL_CONFIRM = 'Emails do not match.'
export const FULLNAME_REQUIRED = 'Full name is required.'
export const TYPE_NUMBER = 'Only numbers are allowed.'

export const APP_CUSTOM_ERROR = 'Oops! Something went wrong, try again later.'
export const APP_TIMEOUT_ERROR = 'Oops! Connection timed out'

export const FIRSTNAME_REQUIRED = 'First name is required.'
export const LASTNAME_REQUIRED = 'Last name is required.'
export const BIRTHDATE_REQUIRED = 'Birth date is required.'
export const BIRTHDATE_MIN = `Minimum age is ${MIN_AGE} years old.`
export const GENDER_REQUIRED = 'Gender is required.'
export const FULLNAME_NO_SPECIAL = 'No numbers or special characters are allowed.'
export const NAME_NO_WHITESPACE = 'Only whitespaces are not allowed'
export const PHONE_REQUIRED = 'Phone number is required'
export const LOCATION_REQUIRED = 'Location is required'
export const FIELD_REQUIRED = 'This field is required'
export const GAME_SCORE_REQUIRED = 'The winner of the game must score a minimum of 6 points.'
export const GAME_CANNOT_DRAW_EMPTY = 'Match cannot be a draw or have empty games in between'
export const SCORE_LESS_ZERO = 'Score cannot be less than 0.'
export const SCORE_OTHER_GAME = 'You must set scores for both teams in a game'
export const SCORE_INTEGER = 'Score must be 0 or a positive integer'
export const TEAM1_REQUIRED = 'Please Select First Opponent'
export const TEAM2_REQUIRED = 'Please Select Second Partner'
export const DATE_REQUIRED = 'Date is required'

export const PHONE_INVALID = 'Please enter a valid phone number.'
export const TYPE_DATE = 'Date format should be MM/DD/YYYY.'

export const EVENT_NAME_REQUIRED = 'Event name is required.'
export const REGISTRATION_URL_REQUIRED = 'Registration URL is required.'
export const EVENT_DESCRIPTION_REQUIRED = 'Event description is required.'
export const EVENT_REFUND_POLICY_REQUIRED = 'Event refund policy is required.'
export const EVENT_ANNOUNCEMENT_TITLE_REQUIRED = 'Subject is required'
export const EVENT_ANNOUNCEMENT_TITLE_MAX = `Maximum ${TITLE_MAX_LENGTH} characters are allowed.`
export const BRACKET_CLUB_MEMBER_PRICE_REQUIRED = 'Club member price is required.'
export const PRICE_DIGIT = `price field must have ${MIN_DIGIT_AFTER_DECIMAL} digits after decimal or less`
export const PRICE_MIN = 'Price should be either 0 or greater than '
export const PRICE_MAX = 'Price should be smaller than 100000'
export const EVENT_ANNOUCEMENT_DESCRIPTION_MIN = `Minimum ${DESCRIPTION_MIN_LENGTH} characters.`
export const EVENT_ANNOUCEMENT_DESCRIPTION_MAX = `Maximum ${DESCRIPTION_MAX_LENGTH} characters.`
export const EVENT_HEALTH_POLICY_REQUIRED = 'Event health and safety policy is required.'

export const BRACKET_NAME_REQUIRED = 'Bracket name is required'
export const BRACKET_TYPE_REQUIRED = 'Bracket Type is required'
export const PLAYER_GROUP_REQUIRED = 'Player group is required'
export const EVENT_TYPE_REQUIRED = 'Event Type is required'
export const MIXED_BRACKET_ERROR = 'Please select different match type'

export const MINIMUM_AGE_REQUIRED = 'Minimum age is required.'
export const MAXIMUM_AGE_REQUIRED = 'Maximum age is required.'
export const AGE_NUMBER = 'Age must be a number.'
export const AGE_MIN = `Minimum age should be ${MIN_AGE} years.`
export const AGE_MAX = `Maximum age should be ${MAX_AGE} years.`
export const AGE_INTEGER = 'Age should be rounded.'
export const AGE_MORE = 'Maximum age should be higher than minimum age.'

export const MAXIMUM_RATING_REQUIRED = 'Maximum rating is required.'
export const RATING_REQUIRED = 'Rating is required.'
export const MINIMUM_RATING_REQUIRED = 'Minimum rating is required.'
export const RATING_NUMBER = 'Rating must be a number'
export const RATING_MIN = `Minimum rating should be ${MIN_RATING}.`
export const RATING_MAX = `Maximum rating should be ${MAX_RATING}.`
export const RATING_MORE = 'Maximum rating should be higher than minimum rating.'
export const RATING_DIGIT = `Maximum ${MIN_DIGIT_AFTER_DECIMAL} digits after decimal.`

export const COURTS_ERROR = `Number of court should be between ${MIN_COURTS} & ${MAX_COURTS}.`
export const COURTS_REQUIRED = 'Number of Court is required.'

export const REG_START_DATETIME_REQUIRED = 'Registration start date and time is required.'
export const REG_END_DATETIME_REQUIRED = 'Registration end date and time is required.'
export const REG_END_DATE_MORE = 'Registration end date must be after registration start date.'
export const COMP_START_DATETIME_REQUIRED = 'Competition start date and time is required.'
export const COMP_START_DATE_MORE = 'Competition start date should be higher than Registration end date.'

export const COMP_END_DATETIME_REQUIRED = 'Competition end date and time is required.'
export const COMP_END_DATE_MORE = 'Competition end date should be higher than competition start date.'

export const SCORE_ERROR = 'Please enter score'
export const MIN_SCORE_ERROR_2 = `Score must be greater than or equal to ${MIN_SCORE_POINTS_2} `
export const TIMEZONE_ERROR = 'Timezone is required.'
export const PHONE_NO_REQUIRED = 'Phone number is required'

export const BRACKET_CLUB_NON_MEMBER_PRICE_REQUIRED = 'Club non-member price is required.'

export const TEAMS_REQUIRED = 'Number of Teams is required.'
export const TEAMS_MIN = `Minimum teams should be ${MIN_TEAMS}.`
export const TEAMS_MAX = `Maximum ${TOTAL_TEAMS} teams can join the bracket.`
export const TEAMS_INTEGER = 'Please enter a whole number.'

export const WAITLIST_REQUIRED = 'Waitlist is required.'
export const WAITLIST_MAX = `Maximum ${TOTAL_WAITLIST} teams can join the waitlist`
export const WAITLIST_MIN = 'Minimum 0 teams can join the waitlist'
export const WAITLIST_INTEGER = 'Please enter a whole number.'

export const LOGO_REQUIRED = 'Logo is required'
export const LIABILITY_WAIVER_REQUIRED = 'Liability waiver is required'

export const FILE_SIZE = `File is too large to handle, maximum allowed size is ${(FILE_MAX_SIZE / 1000000).toFixed(
  2
)} MB.`
export const FILE_TYPE = 'Only PDF or WORD files and JPG or PNG images are allowed.'
export const IMAGE_SIZE = `Image is too large to handle, maximum allowed size is ${(IMAGE_MAX_SIZE / 1000000).toFixed(
  2
)} MB.`
export const IMAGE_TYPE = 'Only JPG or PNG images are allowed.'

export const COMPLETED = 'Completed'
export const COMPLETED_BRACKET_SOURCE = 'Source bracket completed'
export const COMPLETED_BRACKET_TARGET = 'Target bracket completed'
export const ONGOING = 'Ongoing'
export const INPROGRESS_BRACKET = 'source/target bracket is in progress'
export const TARGET_BRACKET_VALIDATED = 'Target bracket matches are validated'
export const SOURCE_BRACKET_VALIDATED = 'Source bracket matches are validated'
export const SAME_BRACKET_MESSAGE = 'Cannot switch within same bracket'
export const REGISTRATION_FULL = 'Registration Full'
export const WAITLIST = 'Waitlist'
export const INVALID_FORMAT = 'Invalid format'
export const INVALID_PLAYER_GROUP = 'Invalid Player Group'
export const INVALID_AGE_BRACKET = 'Invalid AgeGroup Bracket'
export const SCORE_WARNING_MESSAGE =
  'You must complete the match and submit scores for all games within your match at once. If you plan to submit scores for additional games in this match, go back.'

export const VERIFY_EMAIL_ERROR = 'You must verify your email to access the site.'

export const EVENT_ANNOUNCEMENT_CREATED = 'Event announcement created successfully'
export const EVENT_ANNOUNCEMENT_UPDATED = 'Event announcement updated successfully'
